module.exports = __webpack_public_path__ + "static/man-3405bbf8ab1013f1e9f7cc7bb88e84e9.png";